import { render } from "./FormInsurancePolice.vue?vue&type=template&id=7b271d48"
import script from "./FormInsurancePolice.vue?vue&type=script&lang=js"
export * from "./FormInsurancePolice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__